import { DwListItem } from '@dreamworld/dw-list-item/dw-list-item';
 export class SmpvListItem extends DwListItem {

 }
customElements.define('smpv-list-item', SmpvListItem);
